import styles from './ChartItemInfo.css';
import { Image, UIText2 } from '@cian/ui-kit';
import { TColors } from '@cian/ui-kit-design-tokens/colors';

interface IChartInfoItem {
  src: string;
  text: string;
  color: TColors;
}
export function ChartItemInfo({ src, text, color }: IChartInfoItem) {
  return (
    <div className={styles['container']}>
      <div className={styles['img']}>
        <Image src={src} />
      </div>
      <UIText2 fontWeight="400" color={color}>
        {text}
      </UIText2>
    </div>
  );
}
